import React from "react";
import LocationAssignmentItem from "../../../Domain/LocationAssignmentItem";
import TabOfDataTable from "../../../Elements/DataTable/TabOfDataTable";
import urlHelper from "../../../Helpers/urlHelper";
import AssignmentService from "../../../Services/AssignmentService";

class AssignmentListByClientUnitIdComponent extends React.Component {
  static defaultProps = {
    clientUnitId: null,
    locationName: "",
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <div>
        <TabOfDataTable
          type={LocationAssignmentItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={AssignmentService.GetAssignmentExtendedList}
          convertDBItemsFunction={AssignmentService.ConvertDBItemListLocation}
          searchItem={{ AsCcuid: this.props.clientUnitId }}
          redirectLinkOnInfo={urlHelper.generateLeadSearchRedirectUrl("assignments", "AsBillClient=&AsPayEvaluator=&AsSassieAsgnId", "")}
          errorCode="DA211"
        />
      </div>
    );
  }
}

export default AssignmentListByClientUnitIdComponent;
